import React from "react";
import { Container, Button, Row, Col, Card } from "react-bootstrap";
import "./Review.css";
import imageSrc from "../Images/instaImg.jpg"
import { Link } from "react-router-dom";

const Reviews = () => {
  return (
    <>
     <div className="container-xxl py-5 hero-header1">
      <div className="container my-5 py-5 px-lg-5">
        <div className="row g-5 py-5">
          <div className="col-12 text-center">
            <h1 className="text-white animated slideInDown">Reviews</h1>
            <hr className="bg-white mx-auto mt-0" style={{ width: "90px" }} />
          </div>
        </div>
      </div>
    </div>
    <Container className="reviews-container text-center">
      <h2 className="rating">
        ⭐⭐⭐⭐⭐ 4.8/5 Star Rating <span className="review-count">(24,429 reviews)</span>
      </h2>
      <h3 className="sub-title">Fusionsphere Reviews</h3>
      <p className="description mb-5">Growing on Instagram with Fusionsphere llp</p>

      <Link
        to="/get-started#payment-section"
        className="get-started text-decoration-none mt-4 pt-5 py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft"
        
      >
        Get Started
      </Link>
      {/* <Button className="get-started">Get Started</Button> */}
    </Container>

    <Container fluid className="video-image-section">
      <Row className="align-items-center">
        {/* Left Column - Video */}
        <Col md={6} className="video-col">
          <video autoPlay loop muted className="video" id="large1">
            <source src={`${process.env.PUBLIC_URL}/large2.mp4`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Col>

        {/* Right Column - Image */}
        <Col md={6} className="image-col">
          <img src={imageSrc} alt="Display" className="image" />
        </Col>
      </Row>
    </Container>


    {/*  */}
    <section>
        <h2 className="text-center  mt-5 mb-5">Reviews</h2>

        <Container fluid className="cards-section">
      <Row className="justify-content-center">
        {/* Card 1 */}
        <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">autu_mnbella
              Joined in December 2022</Card.Title>
              <Card.Text>
              fusionsphere has been a game-changer in my entrepreneurial journey. The significant boost in engagements and followers has given my business the recognition it deserves, emphasizing the importance of meaningful connections over mere numbers. Through Path Social, I’ve forged valuable relationships with customers, partners, and supporters who share our vision, creating a thriving community around my business.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Card 2 */}
        <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">littlebeachbo
              Joined in March 2023</Card.Title>
              <Card.Text>
              fusionsphere has transformed my startup’s success in a tough market! Since joining forces with them, our online presence has surged, gaining more engagements and followers. This has made us stand out in our industry. Plus, Path Social has helped us secure fantastic partnerships and collaborations, driving our growth and innovation to new levels. They’re an essential part of our entrepreneurial journey, and we can’t wait to achieve even greater things together!
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Card 3 */}
        <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">mastf_urniture
              Joined in February 2022</Card.Title>
              <Card.Text>
              fusionsphere has played a pivotal role in the remarkable success of my startup! Prior to using their services, we were struggling in the shadows, with limited engagements and followers. However, since harnessing the power of Path Social, our online presence has skyrocketed, catapulting us into the well-deserved spotlight. The transformation has been phenomenal; we’ve not only witnessed a surge in engagements and followers but have also drawn the attention of investors, customers, and like-minded partners who wholeheartedly align with our vision.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

         {/* Card 4 */}
         <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">quietparksin
              Joined in October 2022</Card.Title>
              <Card.Text>
              I’m in awe of the results I’ve achieved with fusionsphere help in promoting my nature blog! The boost in engagements and followers has breathed new life into my content. I’ve also connected with fellow nature enthusiasts, forming a supportive community where we share insights and inspirations. It’s not just a win-win; it’s a win for nature, too! This platform has amplified the impact of my message and allowed me to make a meaningful difference in the world of conservation and appreciation for the natural world.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

         {/* Card 5 */}
         <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">theplantres
              Joined in June 2022</Card.Title>
              <Card.Text>
              Using Fusionsphere llp for my outdoor adventure videos has been a revelation. The increase in engagements and followers has been off the charts, and I’m now collaborating with fellow adventure seekers, creating content that inspires and educates people about the beauty of the great outdoors. It’s taken my content to the next level and has given me the opportunity to share my passion for nature with an ever-growing, enthusiastic audience. Together, we’re forging new paths and uncovering hidden gems in the world of outdoor exploration.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

         {/* Card 6*/}
         <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">hiphopthe90_
              Joined in December 2022</Card.Title>
              <Card.Text>
              I’m thrilled to have Path Social’s fantastic support on my ’90s music-inspired journey. Their service is building a dedicated fan base, like a classic ’90s mixtape. From starting in obscurity to rocking the stage for an enthusiastic audience, my Instagram has transformed into a platform where I can genuinely groove to the tunes of my musical passion and connect with fellow ’90s music enthusiasts.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

         {/* Card 7 */}
         <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">nik_party_service
              Joined in April 2022</Card.Title>
              <Card.Text>
              Fusionsphere llp has taken my party entertainment service to new heights I never imagined possible. It’s about building real connections with fellow party lovers who appreciate entertainment. My small Instagram following has transformed into a thriving community where I can proudly share my party expertise and connect with fans deeply. Thanks to Path Social, my party entertainment now reaches a wider and more diverse audience, delighting everyone.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

         {/* Card 8 */}
         <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">mamaa_ndmi
              Joined in January 2023</Card.Title>
              <Card.Text>
              In my motherhood journey, Fusionsphere llp has been as comforting as a warm cup of tea. Their service goes beyond metrics; it’s all about cultivating a space where I can openly share my triumphs and struggles, alongside fellow moms. From connecting over those sleepless nights to celebrating every tiny milestone, my Instagram has blossomed into a vibrant tapestry of maternal love and deep understanding.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

         {/* Card 9 */}
         <Col md={4} sm={12} className="mb-4">
          <Card className="custom-card">
            <Card.Body>
              <Card.Title className="title">littl_ekingst
              Joined in February 2022</Card.Title>
              <Card.Text>
              Embracing motherhood, Fusionsphere llp has been my guiding light through the turbulent seas of new parenthood! Their service is more than just data; it’s about creating a haven where I connect with kindred mom souls who’ve danced through the same beautiful chaos. From swapping invaluable parenting insights to seeking comfort during midnight feeds, my Instagram has metamorphosed into a lifeline of unwavering support and heartwarming camaraderie. Thanks to Path Social,
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
      <div className="btnslast mt-5 mb-5">
    {/* <Button className="get-started ">Get Started</Button> */}
          <Link
        to="/pricing"
        className="get-started text-decoration-none py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft"
        
      >
        Get Started
      </Link>
    </div>
    </section>
    </>
  );
};

export default Reviews;
